var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sort-container",on:{"click":_vm.changeSort}},[_c('u',[_vm._t("default")],2),(_vm.sort.field===_vm.field && _vm.sort.ascending)?_c('md-icon',[_vm._v("keyboard_arrow_up")]):_vm._e(),(_vm.sort.field===_vm.field && !_vm.sort.ascending)?_c('md-icon',[_vm._v("keyboard_arrow_down")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }